import React from 'react';
import { Download, Share2, QrCode } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { downloadVCard, downloadContactCardImage } from '../services/api';
import { toast } from 'sonner';

const ContactCard = () => {
  const handleDownloadVCard = () => {
    try {
      downloadVCard();
      toast.success('Cartão de contato baixado!');
    } catch (error) {
      toast.error('Erro ao baixar cartão');
    }
  };

  const handleDownloadImage = () => {
    try {
      downloadContactCardImage();
      toast.success('Imagem do cartão baixada!');
    } catch (error) {
      toast.error('Erro ao baixar imagem');
    }
  };

  return (
    <section className="py-12 px-4 bg-white" id="contact-card">
      <div className="container mx-auto max-w-4xl">
        <Card className="border-2 border-purple-200 shadow-xl">
          <CardHeader className="bg-purple-50">
            <CardTitle className="text-2xl text-purple-900 flex items-center gap-2">
              <Share2 className="w-6 h-6" />
              Cartão de Contato
            </CardTitle>
            <p className="text-gray-600">Baixe ou compartilhe nosso cartão de contato</p>
          </CardHeader>
          <CardContent className="p-6">
            <div className="grid md:grid-cols-2 gap-6">
              {/* VCard Download */}
              <div className="text-center p-6 bg-purple-50 rounded-lg">
                <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                  <Download className="w-8 h-8 text-purple-600" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  Adicionar aos Contatos
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  Baixe o arquivo vCard e adicione diretamente aos seus contatos
                </p>
                <Button
                  onClick={handleDownloadVCard}
                  className="bg-purple-600 hover:bg-purple-700 text-white"
                >
                  <Download className="w-4 h-4 mr-2" />
                  Baixar vCard (.vcf)
                </Button>
              </div>

              {/* Image Download */}
              <div className="text-center p-6 bg-purple-50 rounded-lg">
                <div className="bg-white w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                  <QrCode className="w-8 h-8 text-purple-600" />
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  Compartilhar Imagem
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  Baixe a imagem do cartão com QR Code do WhatsApp
                </p>
                <Button
                  onClick={handleDownloadImage}
                  variant="outline"
                  className="border-purple-600 text-purple-600 hover:bg-purple-50"
                >
                  <Share2 className="w-4 h-4 mr-2" />
                  Baixar Imagem (.png)
                </Button>
              </div>
            </div>

            <div className="mt-6 text-center text-sm text-gray-600">
              <p>O cartão inclui telefone, email, endereço e QR Code para WhatsApp</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ContactCard;